import React, { useState, useEffect } from 'react';

const SocialMediaManagement = () => {
  const [socialLinks, setSocialLinks] = useState({
    facebook: '',
    twitter: '',
    linkedin: '',
    instagram: '',
    youtube: '',
    telegram: '',
    whatsapp: '',
    discord: ''
  });

  const [contactInfo, setContactInfo] = useState({
    email: 'support@riverprime.com',
    phone: '+1 (555) 123-4567',
    address: '123 Financial District, New York, NY 10001',
    supportHours: 'Monday - Friday: 9:00 AM - 6:00 PM EST'
  });

  const [hasChanges, setHasChanges] = useState(false);

  useEffect(() => {
    // Load saved settings from localStorage
    const savedSocial = localStorage.getItem('adminSocialLinks');
    const savedContact = localStorage.getItem('adminContactInfo');
    
    if (savedSocial) {
      setSocialLinks(JSON.parse(savedSocial));
    }
    if (savedContact) {
      setContactInfo(JSON.parse(savedContact));
    }
  }, []);

  const handleSocialChange = (platform, value) => {
    setSocialLinks(prev => ({
      ...prev,
      [platform]: value
    }));
    setHasChanges(true);
  };

  const handleContactChange = (field, value) => {
    setContactInfo(prev => ({
      ...prev,
      [field]: value
    }));
    setHasChanges(true);
  };

  const handleSave = () => {
    localStorage.setItem('adminSocialLinks', JSON.stringify(socialLinks));
    localStorage.setItem('adminContactInfo', JSON.stringify(contactInfo));
    setHasChanges(false);
    alert('Social media and contact information saved successfully!');
  };

  const socialPlatforms = [
    {
      key: 'facebook',
      label: 'Facebook',
      icon: 'fab fa-facebook-f',
      color: '#1877f2',
      placeholder: 'https://facebook.com/riverprime'
    },
    {
      key: 'twitter',
      label: 'Twitter / X',
      icon: 'fab fa-twitter',
      color: '#1da1f2',
      placeholder: 'https://twitter.com/riverprime'
    },
    {
      key: 'linkedin',
      label: 'LinkedIn',
      icon: 'fab fa-linkedin-in',
      color: '#0077b5',
      placeholder: 'https://linkedin.com/company/riverprime'
    },
    {
      key: 'instagram',
      label: 'Instagram',
      icon: 'fab fa-instagram',
      color: '#e4405f',
      placeholder: 'https://instagram.com/riverprime'
    },
    {
      key: 'youtube',
      label: 'YouTube',
      icon: 'fab fa-youtube',
      color: '#ff0000',
      placeholder: 'https://youtube.com/@riverprime'
    },
    {
      key: 'telegram',
      label: 'Telegram',
      icon: 'fab fa-telegram-plane',
      color: '#0088cc',
      placeholder: 'https://t.me/riverprime'
    },
    {
      key: 'whatsapp',
      label: 'WhatsApp',
      icon: 'fab fa-whatsapp',
      color: '#25d366',
      placeholder: 'https://wa.me/1234567890'
    },
    {
      key: 'discord',
      label: 'Discord',
      icon: 'fab fa-discord',
      color: '#5865f2',
      placeholder: 'https://discord.gg/riverprime'
    }
  ];

  return (
    <div className="admin-section">
      <div className="section-header">
        <h2>Social Media & Contact Management</h2>
        <p>Manage social media links and contact information</p>
      </div>

      {/* Social Media Links */}
      <div className="subsection">
        <h3>Social Media Links</h3>
        <div className="social-grid">
          {socialPlatforms.map((platform) => (
            <div key={platform.key} className="social-card">
              <div className="social-header">
                <div 
                  className="social-icon"
                  style={{ backgroundColor: platform.color }}
                >
                  <i className={platform.icon}></i>
                </div>
                <h4>{platform.label}</h4>
              </div>
              <div className="form-group">
                <input
                  type="url"
                  value={socialLinks[platform.key]}
                  onChange={(e) => handleSocialChange(platform.key, e.target.value)}
                  placeholder={platform.placeholder}
                  className="social-input"
                />
              </div>
              {socialLinks[platform.key] && (
                <div className="social-preview">
                  <a 
                    href={socialLinks[platform.key]} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="preview-link"
                  >
                    <i className="fas fa-external-link-alt"></i>
                    Preview Link
                  </a>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Contact Information */}
      <div className="subsection">
        <h3>Contact Information</h3>
        <div className="contact-grid">
          <div className="contact-card">
            <div className="contact-header">
              <i className="fas fa-envelope"></i>
              <h4>Email Address</h4>
            </div>
            <div className="form-group">
              <input
                type="email"
                value={contactInfo.email}
                onChange={(e) => handleContactChange('email', e.target.value)}
                placeholder="support@riverprime.com"
                className="contact-input"
              />
            </div>
          </div>

          <div className="contact-card">
            <div className="contact-header">
              <i className="fas fa-phone"></i>
              <h4>Phone Number</h4>
            </div>
            <div className="form-group">
              <input
                type="tel"
                value={contactInfo.phone}
                onChange={(e) => handleContactChange('phone', e.target.value)}
                placeholder="+1 (555) 123-4567"
                className="contact-input"
              />
            </div>
          </div>

          <div className="contact-card full-width">
            <div className="contact-header">
              <i className="fas fa-map-marker-alt"></i>
              <h4>Office Address</h4>
            </div>
            <div className="form-group">
              <textarea
                value={contactInfo.address}
                onChange={(e) => handleContactChange('address', e.target.value)}
                placeholder="123 Financial District, New York, NY 10001"
                className="contact-textarea"
                rows="3"
              />
            </div>
          </div>

          <div className="contact-card full-width">
            <div className="contact-header">
              <i className="fas fa-clock"></i>
              <h4>Support Hours</h4>
            </div>
            <div className="form-group">
              <input
                type="text"
                value={contactInfo.supportHours}
                onChange={(e) => handleContactChange('supportHours', e.target.value)}
                placeholder="Monday - Friday: 9:00 AM - 6:00 PM EST"
                className="contact-input"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="section-actions">
        <button 
          className="save-btn" 
          onClick={handleSave}
          disabled={!hasChanges}
        >
          <i className="fas fa-save"></i>
          Save Changes
        </button>
      </div>

      <div className="social-guidelines">
        <h3>Social Media Guidelines</h3>
        <div className="guidelines-grid">
          <div className="guideline-item">
            <i className="fas fa-link"></i>
            <div>
              <strong>URLs:</strong> Use complete URLs starting with https://
            </div>
          </div>
          <div className="guideline-item">
            <i className="fas fa-eye"></i>
            <div>
              <strong>Visibility:</strong> Empty fields will hide social icons
            </div>
          </div>
          <div className="guideline-item">
            <i className="fas fa-shield-alt"></i>
            <div>
              <strong>Security:</strong> Links will open in new tabs
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SocialMediaManagement;